import { useTranslation } from "react-i18next";
import { complexDigitToman, convertToJalaliWithoutTime } from "../../../../tools/tools";
import { useDealer } from "../../../../tools/api";
import ReportPage, { col, PrintButton, usePrintDocument } from "../../../auxiliary/report/ReportPage";
import CSPrint from "../../updateDocument/cs-print";

const CSReport = () => {
	const [t] = useTranslation("global");
	const { querySWPurchaseDealerByDate, querySPPurchaseVProfileDealerById } = useDealer();
	const { busy, print } = usePrintDocument();

	const printDoc = (purchaseProductId) =>
		print(async () => {
			const response = await querySPPurchaseVProfileDealerById(purchaseProductId);
			if (!response) return null;
			return <CSPrint print={{ ...response, kitno: response?.stR_ICCID?.slice(9, 19), msisdn: response?.inT_MSISDN }} />;
		});

	const columns = [
		col("نام کاربری", "username"),
		col("شماره", "msisdn"),
		col("شماره کیت جدید", "newkit"),
		col("شماره کیت قدیم", "oldkit"),
		col("قیمت (تومان)", "price"),
		col("سودفروش (تومان)", "commission"),
		col("تاریخ تعویض", "purchaseDate"),
		col("وضعیت", "status"),
		col("چاپ سند", "printdoc", {
			excel: false,
			render: (_, row) => (
				<PrintButton onClick={() => printDoc(row._raw.purchaseProductId)} />
			),
		}),
	];

	return (
		<ReportPage
			title={t("simcardreplacement.report.title")}
			prefix="cs"
			query={querySWPurchaseDealerByDate}
			columns={columns}
			toRow={(item) => ({
				username: item.username,
				msisdn: item.msisdn,
				newkit: item.newiccid?.toString()?.slice(9, 19),
				oldkit: item.oldiccid?.toString()?.slice(9, 19),
				price: complexDigitToman(item.iccidprice),
				commission: complexDigitToman(item.salesCommission),
				purchaseDate: convertToJalaliWithoutTime(item.purchasedate),
				status: item.simswapstate,
			})}
			excel={{ sheet: "گزارشات تعویض سیم‌کارت", file: "sim-swap-report.xlsx" }}
			busy={busy}
		/>
	);
};

export default CSReport;
